import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Chip,
  Button,
  Grid,
} from '@mui/material';
import {
  LocalChapterDashboard,
  FormStatus,
} from '../../../types/annualReports';
import { useNavigate } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';

interface LocalChapterViewProps {
  data: LocalChapterDashboard;
}

const LocalChapterView: React.FC<LocalChapterViewProps> = ({ data }) => {
  const navigate = useNavigate();

  const renderFormCard = (
    title: string,
    form: FormStatus | undefined,
    summaryLink: string
  ) => {
    if (!form) {
      return (
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                {title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                No form found for {data.chapter_name}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      );
    }

    return (
      <Grid item xs={12} md={6}>
        <Card>
          <CardContent>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                mb: 2,
              }}
            >
              <Typography variant="h6">{title}</Typography>
              <Chip
                label={form.status_name}
                size="small"
                color="primary"
                variant="outlined"
              />
            </Box>

            {form.assigned_to && (
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                Assigned to: {form.assigned_to}
              </Typography>
            )}

            {form.last_updated && (
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Last updated: {new Date(form.last_updated).toLocaleDateString()}
              </Typography>
            )}

            <Box sx={{ display: 'flex', gap: 1 }}>
              {form.can_edit && (
                <Button
                  variant="contained"
                  size="small"
                  startIcon={<EditIcon />}
                  onClick={() => navigate(form.link)}
                >
                  Edit
                </Button>
              )}
              <Button
                variant="outlined"
                size="small"
                startIcon={<VisibilityIcon />}
                onClick={() => navigate(summaryLink)}
              >
                View Summary
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Grid>
    );
  };

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        {data.chapter_name}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Annual Reports for {data.chapter_name}
      </Typography>

      <Grid container spacing={2}>
        {renderFormCard(
          'Roster & Dues',
          data.roster_dues,
          data.roster_dues
            ? `/annual-reports/roster-dues/local-chapter/${data.roster_dues.form_id}/summary`
            : '#'
        )}
        {renderFormCard(
          'IRS-LC',
          data.irs_lc,
          data.irs_lc
            ? `/annual-reports/irs-forms/lc/${data.irs_lc.form_id}/summary`
            : '#'
        )}
      </Grid>
    </Box>
  );
};

export default LocalChapterView;
